import { Spinner } from "@/components/ui";
import { useAuth } from "@/auth/AuthProvider";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function RequireAuth() {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-[var(--color-surface-muted)]">
        <Spinner label="Checking session…" />
      </div>
    );
  }

  if (!session) {
    // Keep search + hash so a deep link with period/compare params survives the login round trip.
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <Outlet />;
}
